import { NgModule, ErrorHandler } from '@angular/core';

import { AppComponent } from './app.component';
import { FilterComponent } from './components/filter/filter.component';
import { SportstreeComponent } from './components/sportstree/sportstree.component';
import { JwtInterceptor } from './services/http/jwtInterceptor.service';
import { QueryParamsService } from './services/http/queryParams.service';
import { SportsProviderService } from './services/providers/sports.provider.service';
import { SportsService } from './services/sports.service';
import { ModelMapperService } from './services/util/model.mapper.service';
import { UtilityService } from './services/util/utility.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EventsService } from './services/events.service';
import { EventsProviderService } from './services/providers/events.provider.service';
import { UserProviderService } from './services/providers/user.provider.service';
import { SettingsProviderService } from './services/providers/settings.provider.service';
import { UserService } from './services/user.service';
import { SettingsService } from './services/settings.service';
import { TicketService } from './services/ticket.service';
import { TicketProviderService } from './services/providers/ticket.provider.service';
import { NotificationService } from './services/notification.service';
import { CashOutService } from './services/cash-out.service';
import { OutcomeExclusionsService } from './services/outcomeExclusion.service';
import { FreeBetService } from './services/freeBet.service';
import { BonusService } from './services/bonus.service';
import { CacheChangesProviderService } from './services/providers/caheChanges.provider.service';
import { CacheChangesService } from './services/cacheChanges.service';
import { IntervalService } from './services/interval.service';
import { UserActivityService } from './services/userActivity.service';
import { ChangesUpdaterService } from './services/changesUpdaterService.service';
import { CommonModule, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import localeSRLATN from '@angular/common/locales/sr-Latn';
import localeENUS from '@angular/common/locales/en';
import localeHRHR from '@angular/common/locales/hr';
import localeSRLATNME from '@angular/common/locales/sr-Latn-ME';
import localeSRLATNBA from '@angular/common/locales/sr-Latn-BA';
import localeENNG from '@angular/common/locales/en-NG';
import localeDEDE from '@angular/common/locales/de';
import { StorageService } from './services/util/storage.service';
import { CacheService } from './services/cache.service';
import { ScrollService } from './services/scroll.service';
import { LoaderService } from './services/loader.service';
// import { BettingLiveComponent } from './components/betting-live/betting-live.component';
import { BettingPrematchComponent } from './components/betting-prematch/betting-prematch.component';
import { SportsTreeBreadcrumbsComponent } from './components/mobile/sports-tree-breadcrumbs/sports-tree-breadcrumbs.component';
import { MessagingService } from './services/messaging.service';
import { MessagingProviderService } from './services/providers/messaging.provider.service';
import { GlobalErrorHandler } from './services/error/globalErrorHandler.service';
import { TaxCalculatorService } from './services/taxCalculator.service';
import { ResultsComponent } from './components/results/results.component';
import { ResultsNavigationComponent } from './components/results-navigation/results-navigation.component';
import { ResultsSportsTreeComponent } from './components/results-sports-tree/results-sports-tree.component';
import { ResultsEventsHeaderComponent } from './components/results-events-header/results-events-header.component';
import { ResultsEventsGroupComponent } from './components/results-events-group/results-events-group.component';
import { ResultsSportsSelectionContainerComponent } from './components/results-sports-selection-container/results-sports-selection-container.component';
import { ResultsEventComponent } from './components/results-event/results-event.component';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { SharedComponentsModule } from './shared-components.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationService } from './ticket-manager/services/authentication.service';
import { AuthentificationProviderService } from './ticket-manager/services/providers/authentification-provider.service';
import { TestComponent } from './components/test/test.component';

registerLocaleData(localeSRLATN);
registerLocaleData(localeENUS);
registerLocaleData(localeENNG);
registerLocaleData(localeHRHR);
registerLocaleData(localeSRLATNME);
registerLocaleData(localeDEDE);
registerLocaleData(localeSRLATNBA);
@NgModule({
  declarations: [
    AppComponent,
    SportstreeComponent,
    FilterComponent,
    // SearchComponent,



    // BettingLiveComponent,
    BettingPrematchComponent,
    SportsTreeBreadcrumbsComponent,
    ResultsComponent,
    ResultsNavigationComponent,
    ResultsSportsTreeComponent,
    ResultsEventsHeaderComponent,
    ResultsEventsGroupComponent,
    ResultsSportsSelectionContainerComponent,
    ResultsEventComponent,
    TestComponent
  ],

  imports: [
    SharedComponentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
   // TicketManagerModule,
    SharedComponentsModule,
    // NgxBarcodeModule
    // CommonModule,
    AppRoutingModule,
    // MaterialModule
    // ScrollingModule
  ],
  providers: [
    EventsService,
    EventsProviderService,
    QueryParamsService,
    SportsService,
    SportsProviderService,
    UtilityService,
    ModelMapperService,
    UserProviderService,
    UserService,
    SettingsProviderService,
    SettingsService,
    TicketService,
    TicketProviderService,
    NotificationService,
    CashOutService,
    OutcomeExclusionsService,
    FreeBetService,
    BonusService,
    CacheChangesProviderService,
    CacheChangesService,
    IntervalService,
    UserActivityService,
    ChangesUpdaterService,
    StorageService,
    CacheService,
    ScrollService,
    LoaderService,
    MessagingService,
    MessagingProviderService,
    TaxCalculatorService,
    GoogleAnalyticsService,
    AuthenticationService,
    AuthentificationProviderService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    // { provide: LOCALE_ID, useValue: 'hr-HR' },
    // { provide: LOCALE_ID, useValue: 'sr-Latn-ME' },
    // { provide: LOCALE_ID, useValue: 'de-DE' },
    // { provide: LOCALE_ID, useValue: 'sr-Latn' },
    // { provide: LOCALE_ID, useValue: 'en-US' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
